import { __awaiter } from '../../_virtual/_tslib.js';
import React__default, { forwardRef, useRef, useContext, useState, useImperativeHandle, useEffect, Fragment } from 'react';
import { AsyncTypeahead, Menu, MenuItem, Highlighter } from 'react-bootstrap-typeahead';
import { AppContext } from '../../app-context.js';
import AppInputStyles from '../app-input/AppInput.module.scss.js';
import FlatInputStyles from '../flat-input/FlatInput.module.scss.js';
import HelperStyles from '../../scss/helper.module.scss.js';
import './Search.scss.js';
import { ReactComponent as SvgMapPinAlt } from '../../icons/MapPinAlt.svg.js';
import { ReactComponent as SvgRecentGrey } from '../../icons/RecentGrey.svg.js';
import { ReactComponent as SvgMapPinGrey } from '../../icons/MapPinGrey.svg.js';
import { ReactComponent as SvgCloseCircle } from '../../icons/CloseCircle.svg.js';
import { getRemValue } from '../../methods/getRemValue.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import { FONT_WEIGHTS } from '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import 'bowser';
import { groupBy } from '../../methods/groupBy.js';
import { getCurrentState } from '../../methods/getCurrentState.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import classNames from 'classnames';

const renderMenu = (results, menuProps, state) => {
    let index = menuProps.showClearOption ? 1 : 0;
    const groupedResults = groupBy(results, "category");
    return (React__default.createElement(Menu, Object.assign({}, menuProps),
        menuProps.showClearOption && (React__default.createElement(MenuItem, { option: { name: "Clear Search", category: "clear" }, position: 0, style: {
                // color: "#1053FF",
                color: "#202124",
                fontSize: getRemValue(16),
                letterSpacing: getRemValue(-0.16),
                fontWeight: FONT_WEIGHTS.bold,
                display: "flex",
                alignItems: "center"
            } },
            React__default.createElement("span", { style: {
                    marginRight: "16px",
                    // backgroundColor: "#1053FF",
                    backgroundColor: "#F9FAFB",
                    borderRadius: "50%",
                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`
                    // height: "38px",
                    // width: "38.79px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0.5
                } },
                React__default.createElement(SvgCloseCircle, { height: 38, width: 38 })),
            " ",
            "Clear Search")),
        groupedResults.map((res, i) => {
            switch (res.key) {
                case "currentLoc":
                    return (React__default.createElement(Fragment, { key: i }, res.items.map((item, j) => {
                        const menuItem = (React__default.createElement(MenuItem, { key: j, option: item, position: index, style: {
                                color: "#1053FF",
                                fontSize: getRemValue(16),
                                letterSpacing: getRemValue(-0.16),
                                fontWeight: FONT_WEIGHTS.bold,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            React__default.createElement("span", { style: {
                                    marginRight: "16px",
                                    backgroundColor: "#1053FF",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                React__default.createElement(SvgMapPinAlt, { height: 15.83, width: 14.25 })),
                            item.name));
                        index++;
                        return menuItem;
                    })));
                case "recent":
                    return (React__default.createElement(Fragment, { key: i }, res.items.map((item, i) => {
                        var _a;
                        const menuItem = (React__default.createElement(MenuItem, { key: i, option: item, position: index, style: {
                                color: "#202124",
                                width: "max-content",
                                fontSize: getRemValue(16),
                                letterSpacing: getRemValue(-0.16),
                                fontWeight: FONT_WEIGHTS.normal,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            res.key === "recent" && (React__default.createElement("span", { style: {
                                    marginRight: "16px",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E6E6E6",
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                React__default.createElement(SvgRecentGrey, { height: 14.25, width: 14.61 }))), (_a = menuProps.labelKey) === null || _a === void 0 ? void 0 :
                            _a.call(menuProps, item)));
                        index++;
                        return menuItem;
                    })));
                case "suggested":
                    return (React__default.createElement(Fragment, { key: i }, res.items.map((item, i) => {
                        var _a;
                        const menuItem = (React__default.createElement(MenuItem, { key: i, option: item, position: index, style: {
                                color: "#202124",
                                fontSize: getRemValue(16),
                                letterSpacing: getRemValue(-0.16),
                                fontWeight: FONT_WEIGHTS.normal,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            res.key === "suggested" && (React__default.createElement("span", { style: {
                                    marginRight: "16px",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E6E6E6",
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                React__default.createElement(SvgMapPinGrey, null))), (_a = menuProps.labelKey) === null || _a === void 0 ? void 0 :
                            _a.call(menuProps, item)));
                        index++;
                        return menuItem;
                    })));
                default:
                    return (React__default.createElement(Fragment, { key: i }, res.items.map((item, i) => {
                        var _a, _b;
                        const menuItem = (React__default.createElement(MenuItem, { key: i, option: item, position: index, style: {
                                // color: "#202124",
                                width: "max-content",
                                fontSize: getRemValue(16),
                                letterSpacing: getRemValue(-0.16),
                                fontWeight: FONT_WEIGHTS.normal,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            React__default.createElement("span", { style: {
                                    marginRight: "16px",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E6E6E6",
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                React__default.createElement(SvgMapPinGrey, null)),
                            React__default.createElement(Highlighter, { search: state.text }, ((_a = menuProps.labelKey) === null || _a === void 0 ? void 0 : _a.call(menuProps, item)) ? (_b = menuProps.labelKey) === null || _b === void 0 ? void 0 : _b.call(menuProps, item) : item.name)));
                        index++;
                        return menuItem;
                    })));
            }
        })));
};
const Search = forwardRef(({ isLoading, options, onSearch, searchText, onSelectItem, selectedItem, onInputChange, id, onFocus, onBlur, labelText, containerStyles, containerClassName, labelStyles, inputWrapperStyles, inputWrapperClassName, inputStyles, isRequired = false, isValid = true, alignment, setFocus, labelKey, placeholder, clear, showClearBtn, showClearOption, prefix, prefixClassName, minLength = 1, labelClassName, inputClassName, activeClassName, dirtyClassName, isFlatInput, maxLength = 25, disabled }, forwardedRef) => {
    const typeaheadRef = useRef(null);
    const { isMobile } = useContext(AppContext);
    const [isActive, setIsActive] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [currInputVal, setCurrInputVal] = useState("");
    const _onInputChange = (input, e) => {
        var _a;
        setCurrInputVal(input);
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(input, e);
        if (!input) {
            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem([]);
            (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.clear();
            // typeaheadRef.current?.blur();
        }
    };
    const _onFocus = () => {
        typeaheadRef.current.inputNode.select();
        setIsActive(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    };
    const _onBlur = (e) => {
        // e.persist();
        setIsDirty(!!e.target.value);
        setIsActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        setCurrInputVal("");
        typeaheadRef.current.toggleMenu();
        // typeaheadRef.current.getInput().value = searchText;
    };
    const _onSelectItem = (selected) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (((_a = selected[0]) === null || _a === void 0 ? void 0 : _a.category) === "clear") {
            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem([]);
            (_b = typeaheadRef.current) === null || _b === void 0 ? void 0 : _b.clear();
            return;
        }
        const currInputVal = yield getCurrentState(setCurrInputVal);
        if (!currInputVal) {
            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(selected);
            (_c = typeaheadRef.current) === null || _c === void 0 ? void 0 : _c.blur();
        }
    });
    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            setCurrInputVal("");
        }
    };
    const _onClickItem = () => {
        setCurrInputVal("");
    };
    const focus = () => {
        var _a;
        (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    useImperativeHandle(forwardedRef, () => ({
        focus
    }));
    useEffect(() => {
        var _a;
        if (setFocus) {
            (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [setFocus]);
    useEffect(() => {
        var _a;
        if (!clear) {
            return;
        }
        (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.clear();
    }, [clear]);
    useEffect(() => {
        if (selectedItem) {
            setIsDirty(true);
        }
        else {
            setIsDirty(false);
        }
    }, [selectedItem]);
    return (React__default.createElement("div", { style: containerStyles, 
        // className={classNames(
        //     HelperStyles.center_vertical +
        //         " " +
        //         AppInputStyles.field_group +
        //         " " +
        //         (isActive ? AppInputStyles.active : "") +
        //         " " +
        //         (isDirty && !isValid ? AppInputStyles.invalid : ""),
        //     containerClassName
        // )}
        className: classNames(HelperStyles.center_vertical, AppInputStyles.field_group, isActive && AppInputStyles.active, isActive && activeClassName, isDirty && !isValid && AppInputStyles.invalid, containerClassName, isFlatInput && isActive && FlatInputStyles.active, isFlatInput && FlatInputStyles.inputContainer) },
        React__default.createElement("label", { htmlFor: id === null || id === void 0 ? void 0 : id.toString(), 
            // className={classNames(
            //     isActive ? AppInputStyles.active : isDirty ? AppInputStyles.dirty : "",
            //     labelClassName,
            // )}
            className: classNames(isFlatInput && FlatInputStyles.label, isActive
                ? AppInputStyles.active +
                    " " +
                    (isFlatInput ? FlatInputStyles.active : "") +
                    " " +
                    activeClassName
                : isDirty
                    ? AppInputStyles.dirty +
                        " " +
                        (isFlatInput ? FlatInputStyles.dirty : "") +
                        " " +
                        dirtyClassName
                    : "", labelClassName), style: labelStyles },
            labelText,
            isRequired && React__default.createElement("span", { className: "required" }, "*")),
        React__default.createElement("div", { style: Object.assign({}, inputWrapperStyles), className: AppInputStyles.input_wrapper +
                " " +
                (isFlatInput ? FlatInputStyles.inputWrapper : "") +
                " " +
                inputWrapperClassName },
            React__default.createElement("div", { className: prefixClassName }, prefix),
            React__default.createElement("div", { className: classNames(AppInputStyles.input +
                    " " +
                    (isFlatInput ? FlatInputStyles.input : "") +
                    +(alignment === "right" && "right_aligned"), inputClassName), style: inputStyles },
                React__default.createElement(AsyncTypeahead, { disabled: disabled, open: isMobile ? true : undefined, ref: typeaheadRef, isLoading: isLoading, options: options, onSearch: onSearch, searchText: searchText, onChange: _onSelectItem, selected: selectedItem && !currInputVal ? [selectedItem] : [], delay: 400, minLength: minLength, useCache: true, 
                    // clearButton
                    id: id, onFocus: _onFocus, onInputChange: _onInputChange, onBlur: _onBlur, labelKey: labelKey, placeholder: placeholder, renderMenu: (results, menuProps, state) => {
                        return renderMenu === null || renderMenu === void 0 ? void 0 : renderMenu(currInputVal ? results : options, Object.assign(Object.assign({}, menuProps), { labelKey,
                            _onClickItem,
                            showClearOption }), state);
                    }, inputProps: {
                        autoComplete: "new-password",
                        shouldSelectHint: (shouldSelect, event) => event.key === "Enter" || shouldSelect,
                        maxLength: maxLength,
                        id: String(id !== null && id !== void 0 ? id : "")
                    }, caseSensitive: false, filterBy: () => true, onKeyDown: onKeyDown }, ({ onClear, selected }) => (React__default.createElement("div", { className: "rbt-aux" }, !!selected.length && showClearBtn && (React__default.createElement(SvgCloseCircle, { onClick: onClear, style: { cursor: "pointer" } })))))))));
});

export { Search as default };
//# sourceMappingURL=Search.js.map
